module.exports = __webpack_public_path__ + "img/3d.c86d9c7a.png";